import type { challenges as en } from '@/i18n/locales/en/challenges';
import type { Translation } from '@/i18n/types';

/** See `src/i18n/locales/en/challenges.ts`. */
export const challenges: Translation<typeof en> = {
  page: {
    title: 'Sfide',
    lead: 'Organizza sfide di squadra: passi, sonno, allenamenti e altro, con una classifica facoltativa.',
    noCompany: 'Seleziona un’azienda per vedere le sue sfide.',
    forbidden: 'Non hai accesso alle sfide di questa azienda.',
    empty: 'Ancora nessuna sfida — creane una.',
  },
  counts: {
    active: 'Sfide attive',
    draft: 'Bozze',
    completed: 'Completate',
    totalParticipants: 'Partecipanti totali',
  },
  sections: {
    activePublished: 'Attive e pubblicate',
    draftsCompleted: 'Bozze e completate',
  },
  card: {
    type: 'Tipo',
    mode: 'Modalità',
    period: 'Periodo',
    goal: 'Obiettivo',
    reward: 'Premio',
    participants: 'Partecipanti',
    engagement: 'Coinvolgimento',
    completion: 'Completamento',
    leaderboardVisible: 'Classifica visibile',
    leaderboardHidden: 'Classifica nascosta',
  },
  mode: {
    individual: 'Individuale',
    group: 'Squadra',
  },
  status: {
    draft: 'Bozza',
    active: 'Attiva',
    paused: 'In pausa',
    completed: 'Completata',
  },
  type: {
    steps: 'Passi',
    sleep: 'Sonno',
    workouts: 'Allenamenti',
    meditation: 'Meditazione',
    custom: 'Personalizzato',
  },
  actions: {
    newChallenge: 'Nuova sfida',
    publish: 'Pubblica',
    pause: 'Metti in pausa',
    resume: 'Riprendi',
    finish: 'Termina',
    duplicate: 'Duplica come bozza',
    duplicateSuffix: 'copia',
    viewLeaderboard: 'Vedi classifica',
    hideLeaderboard: 'Nascondi classifica',
  },
  leaderboard: {
    title: 'Classifica',
    empty: 'Ancora nessun partecipante.',
  },
  form: {
    title: 'Nuova sfida',
    submit: 'Crea sfida',
    cancel: 'Annulla',
    fields: {
      title: 'Titolo',
      description: 'Descrizione',
      type: 'Tipo',
      mode: 'Modalità',
      startDate: 'Data di inizio',
      endDate: 'Data di fine',
      goalValue: 'Valore obiettivo',
      unit: 'Unità',
      reward: 'Premio',
      leaderboardVisible: 'Mostra la classifica ai partecipanti',
    },
    errors: {
      required: 'Questo campo è obbligatorio.',
      endBeforeStart: 'La data di fine non può precedere la data di inizio.',
    },
  },
};
